// @ts-nocheck

import TxPoolScene from './TxPoolScene.ts'
import TxSprite from './TxSprite.ts'
import { logTxSize, byteTxSize } from '../utils/misc.ts'
const settingsValue = {
	darkMode: true,
	showNetworkStatus: true,
	showFX: true,
	vbytes: false,
	colorByFee: false,
	showMessages: true,
	showSearch: true,
	noTrack: false,
	blocksEnabled: true
}
const config = {layoutHints: false}
export default class TxMondrianPoolScene extends TxPoolScene {
  constructor ({ width, height, unit, padding, controller, heightStore, colorMode, divRef }) {
    super({ width, height, unit, padding, controller, heightStore, colorMode, divRef })
  }

  resize ({ width, height, unit, padding }) {
    super.resize({ width, height, unit, padding })
    this.resetLayout()
  }

  resetLayout () {
    if (this.layout) this.layout.destroy()
    this.layout = new MondrianLayout({ width: this.blockWidth, height: this.blockHeight, context: this })
  }

  txSize (tx={ value: 1, vbytes: 1 }) {
    if (settingsValue.vbytes) return byteTxSize(tx.vbytes, this.blockWidth)
    else return logTxSize(tx.value, this.blockWidth)
  }

  place (tx) {
    const size = this.txSize(tx)
    const position = this.layout.place(tx, size)
    tx.gridPosition.x = position.x
    tx.gridPosition.y = position.y
    tx.gridPosition.r = position.r
  }

  doScroll (offset) {
    super.doScroll(offset)
    this.layout.redraw()
    this.layout.clearOffscreen()
  }

  selectAt (position) {
    if (this.layout) {
      const gridPosition = this.screenToGrid(position)
      return this.layout.getTxInGridCell(gridPosition)
    } else return null
  }

  drop (id) {
    let tx = this.txs[id]
    if (tx && tx.gridSquare) {
      this.layout.remove(tx.gridSquare)
    }
    delete this.txs[id]
    return !!tx
  }
}

class MondrianLayout {
  constructor ({ width, height, context }) {
    this.width = width
    this.height = height
    this.context = context

    this.rowOffset = 0
    this.rows = []
    this.txMap = []
  }

  getRow (position) {
    return this.rows[position.y - this.rowOffset]
  }

  getSlot (position) {
    if (this.getRow(position)) {
      return this.getRow(position).map[position.x]
    }
  }

  addRow () {
    const newRow = { y: this.rows.length + this.rowOffset, slots: [], map: {}, max: 0 }
    this.rows.push(newRow)
    return newRow
  }

  clearOffscreen () {
    let done = false
    const cutoff = -(this.context.scene.scroll + this.context.scene.offset.y) / this.context.gridSize
    while (!done && this.rows.length) {
      const head = this.rows[0]
      let max = 0
      head.slots.forEach(x => {
        max = Math.max(max, x.r)
      })
      if (head.y + max < cutoff) {
        this.rowOffset++
        this.destroyRow(head)
        this.rows.shift()
        this.txMap.shift()
      } else {
        done = true
      }
    }
  }

  addSlot (slot) {
    if (slot.r <= 0) return

    if (this.getSlot(slot)) {
      const existingSlot = this.getSlot(slot)
      if (slot.r > existingSlot.r) {
        existingSlot.r = slot.r
        this.updateSlotSprite(existingSlot)
      }
      return existingSlot
    } else {
      let insertAt = null
      const row = this.getRow(slot)
      if (!row) {
        return
      }
      for (let i = 0; i < row.slots.length && insertAt == null; i++) {
        if (row.slots[i].x > slot.x) {
          insertAt = i
        } else {
        }
      }
      if (insertAt == null) row.slots.push(slot)
      else row.slots.splice(insertAt || 0, 0, slot)
      row.map[slot.x] = slot

      return slot
    }
  }

  removeSlot (slot) {
    const row = this.getRow(slot)
    if (row) {
      delete row.map[slot.x]
      let indexOf = row.slots.indexOf(slot)
      row.slots.splice(indexOf, 1)
    }
    if (slot.sprite) slot.sprite.destroy()
  }

  fillSlot (slot, squareWidth) {
    const square = {
      left: slot.x,
      right: slot.x + squareWidth,
      bottom: slot.y,
      top: slot.y + squareWidth
    }

    this.removeSlot(slot)

    for (let rowIndex = slot.y; rowIndex < square.top; rowIndex++) {
      const row = this.getRow({ y: rowIndex })
      if (row) {
        let collisions = []
        let maxExcess = 0
        for (let i = 0; i < row.slots.length; i++) {
          const testSlot = row.slots[i]
          if (!((testSlot.x + testSlot.r < square.left) || (testSlot.x >= square.right))) {
            collisions.push(testSlot)
            let excess = Math.max(0, (testSlot.x + testSlot.r) - (slot.x + slot.r))
            maxExcess = Math.max(maxExcess, excess)
          }
        }
        if (square.right < this.width && !row.map[square.right]) {
          this.addSlot({ x: square.right, y: rowIndex, r: (slot.r - squareWidth + maxExcess) })
        }

        for (let i = 0; i < collisions.length; i++) {
          collisions[i].r = slot.x - collisions[i].x
          if (collisions[i].r > 0) this.updateSlotSprite(collisions[i])
          else this.removeSlot(collisions[i])
        }
      } else {
        this.addRow()
        if (slot.x > 0) this.addSlot({ x: 0, y: rowIndex, r: slot.x })
        if (square.right < this.width) this.addSlot({ x: square.right, y: rowIndex, r: this.width - square.right})
      }
    }

    for (let rowIndex = Math.max(0, slot.y - squareWidth); rowIndex < slot.y; rowIndex++) {
      const row = this.getRow({ y: rowIndex })
      if (row) {
        for (let i = 0; i < row.slots.length; i++) {
          const testSlot = row.slots[i]
          if ((testSlot.x < slot.x + squareWidth) && (testSlot.x + testSlot.r > slot.x) && (testSlot.y + testSlot.r >= slot.y)) {
            const oldSlotWidth = testSlot.r
            testSlot.r = slot.y - testSlot.y
            if (testSlot.r > 0) this.updateSlotSprite(testSlot)
            else this.removeSlot(testSlot)
            let remaining = {
              x: testSlot.x + testSlot.r,
              y: testSlot.y,
              w: oldSlotWidth - testSlot.r,
              h: testSlot.r
            }
            while (remaining.w > 0 && remaining.h > 0) {
              if (remaining.w <= remaining.h) {
                this.addSlot({ x: remaining.x, y: remaining.y, r: remaining.w })
                remaining.y += remaining.w
                remaining.h -= remaining.w
              } else {
                this.addSlot({ x: remaining.x, y: remaining.y, r: remaining.h })
                remaining.x += remaining.h
                remaining.w -= remaining.h
              }
            }
          }
        }
      }
    }

    return { x: slot.x, y: slot.y, r: squareWidth }
  }

  place (tx, size) {
    let found = false
    let rowIndex = 0
    let row
    let slotIndex = 0
    let square = null
    while (!found && rowIndex < this.rows.length) {
      row = this.rows[rowIndex]
      while (!found && slotIndex < row.slots.length) {
        const testSlot = row.slots[slotIndex]
        if (testSlot.r >= size) {
          found = true
          square = this.fillSlot(testSlot, size)
        }
        slotIndex++
      }
      slotIndex = 0
      rowIndex++
    }
    if (!found) {
      const row = this.addRow()
      const slot = this.addSlot({ x: 0, y: row.y, r: this.width })
      square = this.fillSlot(slot, size)
    }

    tx.gridSquare = square

    for (let x = 0; x < square.r; x++) {
      for (let y = 0; y < square.r; y++) {
        this.setTxMapCell({ x: square.x + x, y: square.y + y }, tx)
      }
    }

    return square
  }

  remove (square) {
    for (let x = 0; x < square.r; x++) {
      for (let y = 0; y < square.r; y++) {
        this.clearTxMapCell({ x: square.x + x, y: square.y + y })
        if (x <= y) this.addSlot({ x: square.x + x, y: square.y + y, r: square.r - y })
      }
    }
  }

  setTxMapCell (coord, tx) {
    const offsetY = coord.y - this.rowOffset

    while (this.txMap.length <= offsetY) {
      this.txMap.push(new Array(this.width).fill(null))
    }
    this.txMap[offsetY][coord.x] = tx
  }

  clearTxMapCell (coord, tx) {
    const offsetY = coord.y - this.rowOffset
    while (this.txMap.length <= offsetY) {
      this.txMap.push(new Array(this.width).fill(null))
    }
    if (this.txMap[offsetY]) this.txMap[offsetY][coord.x] = null
  }

  getTxInGridCell(coord) {
    const offsetY = coord.y - this.rowOffset
    if (this.txMap[offsetY]) return this.txMap[offsetY][coord.x]
    else return null
  }

  slotToSprite (slot) {
    const pos = this.context.pixelsToScreen(this.context.gridToPixels(slot))
    return {
      x: pos.x,
      y: pos.y,
      r: pos.r,
      h: 0.5,
      l: 0.5,
      alpha: 0.5
    }
  }

  updateSlotSprite (slot) {
    if (config.layoutHints) {
      slot.sprite.update({
        ...this.slotToSprite(slot),
        duration: 500,
        minDuration: 500,
        adjust: true
      })
    }
  }

  redraw () {
    if (config.layoutHints) {
      this.rows.forEach(row => {
        row.slots.forEach(slot => {
          this.updateSlotSprite(slot)
        })
      })
    }
  }

  destroyRow (row) {
    if (config.layoutHints) {
      row.slots.forEach(slot => {
        slot.sprite.destroy()
      })
    }
  }

  destroy () {
    if (config.layoutHints) {
      this.rows.forEach(row => {
        row.slots.forEach(slot => {
          slot.sprite.destroy()
        })
      })
    }
  }
}
